import styled from "styled-components";

import { flexColumn, rem } from "@styles/Utilities.styled";


export const StyledTimeBlockManager = styled.div`
  ${flexColumn}
  width: 100%;
  gap: ${rem(12)};

  .day-section {
    ${flexColumn}
    width: 100%;
    padding: ${rem(12)};
    border: 1px solid var(--clr-gray-150);
    border-radius: var(--border-radius-3);
    background-color: var(--clr-gray-100);

    .day-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: ${rem(12)};

      .day-name {
        font-weight: 500;
        font-size: ${rem(14)};
        color: var(--clr-gray-700);
      }
    }

    .time-blocks {
      ${flexColumn}
      gap: ${rem(8)};
      width: 100%;
    }

    .time-block {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr auto;
      gap: ${rem(8)};
      align-items: end;
      padding: ${rem(12)};
      background-color: var(--clr-white);
      border-radius: var(--border-radius-2);
      border: 1px solid var(--clr-gray-200);

      .time-field {
        width: 100%;
      }

      .remove-btn {
        align-self: center;
      }
    }

    .add-block-btn {
      margin-top: ${rem(4)};
      width: fit-content;
    }
  }

  .no-days-selected {
    padding: ${rem(16)};
    text-align: center;
    color: var(--clr-gray-400);
    background-color: var(--clr-gray-100);
    border-radius: var(--border-radius-3);
    font-size: ${rem(14)};
  }
`;
